import { motion } from "framer-motion";

const ITEMS = [
  "Private Transport",
  "Bilingual Expert Guides",
  "Gourmet Dining Included",
  "24/7 Concierge Service",
  "Tailored Itineraries",
  "Exclusive Access",
  "Private Transport",
  "Bilingual Expert Guides",
  "Gourmet Dining Included",
  "24/7 Concierge Service",
  "Tailored Itineraries",
  "Exclusive Access",
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="relative border-y border-white/[0.06] bg-[#050505] overflow-hidden py-5">
      <div className="flex animate-marquee whitespace-nowrap">
        {ITEMS.map((item, i) => (
          <span key={`${item}-${i < ITEMS.length / 2 ? "a" : "b"}`} className="flex items-center shrink-0">
            <span className="font-sans text-[10px] md:text-xs tracking-[0.25em] uppercase text-white/40 px-6 md:px-10">
              {item}
            </span>
            <span className="text-[#C5A059]/40 text-[8px]">&#9670;</span>
          </span>
        ))}
      </div>
    </section>
  );
}
